import React from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact, gtmEvent } from "higher-order-components"
import { Button, Heading } from "components"
import { gtmMyMazdaSummaryActionTypes } from "store/gtm-events"
import { Interactive } from "AtomicComponents"

/*

exterior
:
"Cool White"
grade
:
"XTR"
modelCode
:
"B32QAPDS4"
nameplate
:
"BT-50"
rego
:
"CZF29G"
transmission
:
"4X4 - 6-SP Auto"
vin
:
"MM0UP0YF100426374"
*/

const Desc = ({ name, value }) => (
  <div
    style={{
      padding: "1em",
      textAlign: "left",
      boxSizing: "border-box"
    }}>
    {value && (
      <div style={{ color: "#999", fontSize: "90%", whiteSpace: "nowrap" }}>
        <Interactive>{name}</Interactive>
      </div>
    )}
    {value && <div style={{ color: "#101010", fontWeight: 200 }}>{value}</div>}
  </div>
)

Desc.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string
}

const MyMazdaSummary = (props) => {
  const {
    heading,
    description,
    rego,
    vin,
    grade,
    exterior,
    compact,
    drive,
    transmission,
    engine,
    fullSpecificationsUrl,
    error,
    style,
    gtmEvent
  } = props
  if (error) {
    return (
      <div
        style={{
          margin: "auto",
          maxWidth: "50vw",
          textAlign: "center",
          padding: "4em",
          color: "red"
        }}>
        {error}
      </div>
    )
  }

  const ctaLabel = "view full specification"

  return (
    <div style={{ ...{ padding: "2em" }, ...style }}>
      <div style={{ textAlign: "center", margin: "auto" }}>
        {heading && (
          <div style={{ padding: "2em 0" }}>
            <Heading value={heading} textAlign="center" />
          </div>
        )}
        {description && (
          <div
            style={{ fontWeight: 300, lineHeight: 1.8 }}
            dangerouslySetInnerHTML={{ __html: description }} />
        )}
        <div style={styles.details(compact)}>
          <div
            style={{
              flexBasis: "33%",
              flexGrow: 0,
              flexShrink: 0
            }}>
            <Desc name="Registration number" value={rego || "Contact Dealer"} />
            <Desc name="Vin" value={vin} />
          </div>
          <div
            style={{
              flexGrow: 0,
              flexShrink: 1
            }}>
            <Desc name="Grade" value={grade} />
            <Desc name="Exterior" value={exterior} />
          </div>
          <div
            style={{
              flexBasis: "33%",
              flexGrow: 0,
              flexShrink: 0
            }}>
            <Desc name="Drive & transmission" value={`${drive} ${transmission}`} />
            <Desc name="Engine" value={engine} />
          </div>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'center'
        }}>
          {fullSpecificationsUrl && (
            <Button
              type="a"
              display="inline"
              styleName="blackOutlined"
              href={fullSpecificationsUrl}
              label={ctaLabel}
              gtm={{
                category: "My New Mazda Home",
                action: `Specifications - Clicked "${ctaLabel.toUpperCase()}"`
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

MyMazdaSummary.propTypes = {
  heading: PropTypes.heading,
  description: PropTypes.string,
  compact: PropTypes.bool,
  rego: PropTypes.string,
  vin: PropTypes.string,
  grade: PropTypes.string,
  drive: PropTypes.string,
  exterior: PropTypes.string,
  transmission: PropTypes.string,
  engine: PropTypes.string,
  fullSpecificationsUrl: PropTypes.string,
  error: PropTypes.string,
  style: PropTypes.object,
  gtmEvent: PropTypes.func
}

const styles = {
  details: compact => ({
    display: compact ? "block" : "flex",
    justifyContent: "space-around",
    maxWidth: "70em",
    fontSize: "95%",
    borderTop: "1px solid #cccccc",
    borderBottom: "1px solid #cccccc",
    margin: "0 auto",
    padding: "2em 0",
    marginTop: "2em",
    marginBottom: "2em"
  }),
  detailItem: {
    flexGrow: 0,
    flexShrink: 0
  }
}

export default withRadium(DetectCompact(), gtmEvent())(MyMazdaSummary)



// WEBPACK FOOTER //
// ./src/containers/mymazda-summary/index.jsx